module.exports = __webpack_public_path__ + "img/chickenGif.94f9ac65.gif";